import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import {
    ApiResult,
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { PatientviewService } from 'src/app/services/patientview/patientview.service';

@Component({
    selector: 'app-medical-reports',
    templateUrl: './medical-reports.component.html',
    styleUrls: ['./medical-reports.component.css']
})
@TraceClassDecorator()
export class MedicalReportsComponent implements OnInit {
    @Input('patient_guid')
    patient_guid: string = '';

    // response: PromiseResult;
    // serverError: ServerError;

    MedicalReports: MedicalReports = new MedicalReports();

    constructor(private readonly patientviewService: PatientviewService) {}

    async ngOnInit() {}

    async init() {
        this.MedicalReports.data.patient_guid = this.patient_guid;
        await this.getDocuments();
    }

    async getDocuments() {
        this.MedicalReports.data.api_result.Posting = true;
        await this.patientviewService
            .getPatientViewDocuments(this.MedicalReports.data.patient_guid)
            .toPromise()
            .then((result) => {
                let a: PromiseResult = result;
                if (result.success) {
                    a.data = a.data.data;
                } else {
                    a.data = {};
                }
                this.MedicalReports.data.api_result.PromiseResult = a;
                this.MedicalReports.data.api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.MedicalReports.data.api_result.ServerError = error.error;
                this.MedicalReports.data.api_result.Posting = false;
                this.MedicalReports.data.api_result.PromiseResult.success =
                    false;
            });
        // this.MedicalReports.data.api_result.Posting = false;
    }
}

export class MedicalReports {
    data: {
        patient_guid: string;
        api_result: ApiResult;
    } = {
        patient_guid: '',
        api_result: new ApiResult(true)
    };
}
